import React, { useState, useEffect, useRef } from 'react';
import { StyledButtonSalvar, StyledButtonNovo, StyledButtonPesquisar } from '../styles';
import { Label, ButtonContainer, ShowInput, MainContainer, ProfileContainerInfo, FormContainer, Row } from './styles';
import Swal from 'sweetalert2';
import { geographicCoordinatesService } from '../../../services/geographicCoordinatesService';
import Search from './Search';
import CloseButton from './CloseButton';
import { motion } from "framer-motion";
import { useSelector } from "react-redux";

const GeographicCoordinates = ({ project_id }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [id, setId] = useState('');
  const [descricao, setDescricao] = useState('');
  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const descricao1Ref = useRef(null);
  const collapsed = useSelector((state) => state.sidebar);

  useEffect(() => {
    if (selectedItem) {
      setId(selectedItem.id);
      setDescricao(selectedItem.descricao);
      setLatitude(selectedItem.latitude);
      setLongitude(selectedItem.longitude);
    }
  }, [selectedItem]);

  const handleSalvarClick = async () => {
    setIsLoading(true);

    try {
      const formData = new FormData();
      formData.append('id', id);
      formData.append('descricao', descricao);
      formData.append('latitude', latitude);
      formData.append('longitude', longitude);
      formData.append('project', parseInt(project_id));

      const token = sessionStorage.getItem('Authorization');

      let response; // ✅ Declara a variável antes do if

      // Verifica se o ID está preenchido
      if (id === '' || !id) {
        // 🟢 Inserir nova coordenada
        response = await geographicCoordinatesService.insertCoordinate(formData, token);
        console.log('✅ Inserido com sucesso! Resposta da API:', response);
      } else {
        // 🟡 Atualizar coordenada existente
        response = await geographicCoordinatesService.updateCoordinate(id, formData, token);
        console.log('✅ Atualizado com sucesso! Resposta da API:', response);
      }

      // Limpar campos
      setId('');
      setDescricao('');
      setLatitude('');
      setLongitude('');
      descricao1Ref.current.focus();

      Swal.fire({
        title: 'Sucesso!',
        text: 'Seus dados foram salvos com sucesso!',
        icon: 'success',
        confirmButtonText: 'OK',
      });
    } catch (error) {
      console.error('Erro na chamada da API:', error);

      Swal.fire({
        title: 'Erro!',
        text: 'Algo deu errado. Por favor, contate nosso suporte! suporte@vertecotech.com',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleNovoClick = () => {
    setId('');
    setDescricao('');
    setLatitude('');
    setLongitude('');
    descricao1Ref.current.focus();
  };

  const handlePesquisarClick = () => {
    setIsSearching(!isSearching);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    descricao1Ref.current.focus();
  };

  const PreencheItem = (item) => {
    setSelectedItem(item);
    console.log("coordenadas geográficas : " + selectedItem);
  };

  return (
    <MainContainer>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.8 }}
      >
        <ProfileContainerInfo collapsed={collapsed}>
          <h2>Coordenada Geográfica - Graus Decimais (DD)</h2>

          <FormContainer>

            <Row>
              <Label htmlFor="descricao">Descrição</Label>
              <ShowInput
                style={{ width: '335px' }}
                type="text"
                id="descricao"
                name="descricao"
                value={descricao}
                onChange={(e) => setDescricao(e.target.value)}
                ref={descricao1Ref}
              />
            </Row>

            <Row>
              <Label htmlFor="latitude">Latitude</Label>
              <ShowInput
                style={{ width: '335px' }}
                type="text"
                id="latitude"
                name="latitude"
                value={latitude}
                onChange={(e) => setLatitude(e.target.value)}
              />
            </Row>

            <Row>
              <Label htmlFor="longitude">Longitude</Label>
              <ShowInput
                style={{ width: '335px' }}
                type="text"
                id="longitude"
                name="longitude"
                value={longitude}
                onChange={(e) => setLongitude(e.target.value)}
              />
            </Row>

          </FormContainer>
        </ProfileContainerInfo>

        <ButtonContainer>
          <StyledButtonSalvar style={{ width: '110px' }} onClick={handleSalvarClick}>Salvar</StyledButtonSalvar>
          <StyledButtonNovo style={{ width: '110px' }} onClick={handleNovoClick}>Novo</StyledButtonNovo>
          <StyledButtonPesquisar style={{ width: '110px' }} onClick={handlePesquisarClick}>Pesquisar</StyledButtonPesquisar>
        </ButtonContainer>

        {isModalOpen && (
          <div>
            <CloseButton closeModal={closeModal} />
            <Search onCloseModal={closeModal} PreencheItem={PreencheItem} />
          </div>
        )}
      </motion.div>
    </MainContainer>
  );
};

export default GeographicCoordinates;
